module.exports = __webpack_public_path__ + "static/media/suggestion_icon.759a2f0c.svg";